<template>		
	<v-card outlined dark
		style="width: 100%; height: 100%; object-fit: fill;"
		
		
	>
		<v-system-bar lights-out dark class="vue-draggable-handle">	
			<v-spacer></v-spacer>	
			<v-icon small 
				class="no-dragg primary--text mx-2"				
				@click="redirect_config_host"
			>
				mdi-pencil
			</v-icon>
			<v-btn x-small outlined icon color="error"
				@click="$emit('close_component', layout_id)"				
			>
				<v-icon x-small color="error" class="ml-1" outlined>mdi-close</v-icon>
			</v-btn>
		</v-system-bar>			 
		<v-card-text
			style="width: 100%; height: 100%; object-fit: fill;"
			ref="cardChart"
			class="pa-0"
		>
		 	<GChart
		 		id="chart"
		 		style="width: 100%; height: 95%; object-fit: fill;"
			    type="LineChart"
			    :data="chartData"
			    :options="chartOptions"
			    :resizeDebounce="500"
			/>				
		</v-card-text>
	</v-card>	
</template>
<script>
import { GChart } from 'vue-google-charts'
	export default{
		name: 'graphics',
		components:{
			GChart
		},
		props:[
			'layout', 
			'layout_id'
		],
		data:() =>({
		 	chartData: [
		        ['Time', 'Guns', 'Person', 'Pet', 'LPR'],//'Year', 'Sales', 'Expenses', 'Profit'
		        ['7:00 ', 100, 400, 10, 200 ],
		        ['10:00', 80, 460, 80, 300],
		        ['12:00', 30, 1120, 60, 222],
		        ['15:00', 25, 540, 100, 1234]
		      ],
	      	chartOptions: {
		        chart: {
		          title: 'Events', //Company Performance
		          subtitle: 'daily, weekly', //Sales, Expenses, and Profit: 2014-2017

		        },
	        	colorAxis: { colors: ["blue", "pink", "green", "red"] },
	        	chartArea:{
				    fill: '#FF0000',
          			fillOpacity: 0.1,


				},
				backgroundColor: {
			        gradient: {
			          // Start color for gradient.
			          color1: '#121212',
			          // Finish color for gradient.
			          color2: '#121212',
			          // Where on the boundary to start and
			          // end the color1/color2 gradient,
			          // relative to the upper left corner
			          // of the boundary.
			          x1: '0%', y1: '0%',
			          x2: '100%', y2: '100%',
			          // If true, the boundary for x1,
			          // y1, x2, and y2 is the box. If
			          // false, it's the entire chart.
			          useObjectBoundingBoxUnits: true
        			},
      			},
        		hAxis: {
				    textStyle:{color: '#FFF'}
				},
				vAxis: {					
					textStyle:{color: '#FFF'},				
				    gridlines: {color: '#787878'}
				},
				legend:{
					textStyle: {color: '#FFF'}
				},
				width: '100%',
				height: '100%'
	     	},
	     	size_height: 100,
			size_width: 100,
		}),// data
		watch:{
			/*data: function(v){
				this.chartData=[
					['date', v.title ],
					[v.title, v.graphics]
				];
				this.chartOptions={
			        chart: {
			        title: 'Events', //Company Performance
			        subtitle: v.title, //Sales, Expenses, and Profit: 2014-2017
			        }
	     		};
			}*/
			layout: function(val){
				this.resize_graffics();
			},
		},
		methods:{
			resize_graffics(){
				// this.refs.card_chart;
				let size_h=document.getElementById('chart');
				//document.getElementById("chart");
				console.log("this.refs.card_chart", this.$refs.cardChart.clientHeight);
			
					// this.size_height=this.$refs.cardChart.clientHeight;//
					// this.size_width=this.$refs.cardChart.clientWidth;//
					// this.chartOptions={
					// 	width: this.size_height,
					// 	height: this.size_width,
					// }
					// size_h.style.height
					// size_h.style.width

					// size_h.draw(this.chartData, this.chartOptions);
				console.log("size_h", size_h);
			},
		},// methods

		mounted(){
			
		}, // mounted
	} //export default
</script>